import React from 'react';
import { Collapse, List, ListItem, ListItemButton } from '@mui/material';
import type { ListSections, SideListProps } from './types';

export const SideList: React.FunctionComponent<SideListProps> = (
  props: SideListProps,
) => {
  const { onChangeActivated, listSections, activatedForm } = props;

  const handleViewApplicationForm = (item: string) => (): void => {
    onChangeActivated(item);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  return (
    <>
      <div className="px-2 ml-2">
        <List sx={{ fontSize: 14, width: '100%', padding: 0 }}>
          {listSections.map((section: ListSections, index) => (
            <React.Fragment key={index}>
              <span className="font-bold text-[#951d1d]">{section.title}</span>
              <Collapse in={true}>
                <List disablePadding>
                  {section.items.map(item => (
                    <ListItemButton
                      key={item}
                      selected={activatedForm === item}
                      className="!p-0 !m-0"
                      onClick={handleViewApplicationForm(item)}
                    >
                      <ListItem sx={{ whiteSpace: 'nowrap' }}>{item}</ListItem>
                    </ListItemButton>
                  ))}
                </List>
              </Collapse>
            </React.Fragment>
          ))}
        </List>
      </div>
    </>
  );
};
